import { render } from "./IFrame.vue?vue&type=template&id=b7f75786&ts=true"
import script from "./IFrame.vue?vue&type=script&lang=ts"
export * from "./IFrame.vue?vue&type=script&lang=ts"

import "./IFrame.vue?vue&type=style&index=0&id=b7f75786&lang=scss"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__